export const formLimit = {
    nameLimit: 120,
    mailLimit: 150,
    phoneLimit: 50,
    addressLimit:50,
    cityLimit:50,
    vatLimit:30,
    companyName: 150,
    purchaseOrderLimit: 50,
    netKilosLimit: 50,
    boxType: 10,
    speciesSizeLimit: 50,
    categoryLimit: 50,
    basePallets: 50,
    otherCertificateLimit: 50,
    otherPackagingLimit: 50,
    grossKilosLimit:50,
    caseSizeLimit: 50,
    companyRegistrationLimit: 30,
    programName: 100,
    legalRepresentativeNumber: 25
}
